import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fullscreen-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_authenticate = _resolveComponent("authenticate")!
  const _component_layout = _resolveComponent("layout")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_loading, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Starting app...", -1)
            ]))]),
            _: 1
          })
        ]))
      : (_ctx.notLoggedIn)
        ? (_openBlock(), _createBlock(_component_authenticate, { key: 1 }))
        : (_openBlock(), _createBlock(_component_layout, { key: 2 })),
    _createVNode(_component_alert_box)
  ], 64))
}